<script>
  import fetchWrapper from '@/lib/fetchWrapper.js';
  import storefront from '@/lib/storefront.js';
  import * as queries from '@/lib/queries.js';
  import { emitter } from '@/main.js';
  import { toRaw } from 'vue';
  import { getFinalSaleLineItemProperties, handleViewportSize } from '@/lib/vue-helpers.js';
  export default {
    name: 'CompleteTheLookDisplay',
    props: {
      ctlIds: String,
      addToCartText: String,
      SoldOutText: String,
      notavail: {
        type: Boolean,
        required: true
      },
      comingsoon_tag: {
        type: String,
        required: false
      },
      comingsoonText: {
        type: String,
        required: true
      },
      unavailableText: {
        type: String,
        required: true
      },
      optiontwoorder: {
        type: String,
        required: false
      },
      optiontwoorderoverride: {
        type: String,
        required: false
      },
      optiontwoorderoverridetag: {
        type: String,
        required: false
      },
      optionthreeorder: {
        type: String,
        required: false
      },
      hideOption3TitleTags: {
        type: String,
        required: false
      },
      reactiveCtlTags: {
        type: String,
        required: false
      },
      showImage2: {
        type: Boolean,
        default: false
      },
      showImage3: {
        type: Boolean,
        default: false
      }
    },
    mounted() {
      this.handleViewportSize = handleViewportSize(this);
      this.setTag();
      emitter.on('ctl-products-updated', e => {
        this.hasProducts = e.hasProducts;
      });
    },
    beforeUnmount() {
      if (this.handleViewportSize) this.handleViewportSize();
    },
    data() {
      return {
        CTLPids: [],
        fullProducts: [],
        cleanProducts: [],
        products: [],
        masterProductTitle: '',
        masterProductId: '',
        bagMessage: '',
        activeVariant: '',
        activeComparePrice: '',
        activePrice: '',
        percentage: '',
        collectionTitle: '',
        sizes: [],
        stones: [],
        currentSize: '',
        currentStone: '',
        currentColor: '',
        optOneName: '',
        optTwoName: '',
        selectedProduct: null,
        hasProducts: true,
        currentVariantAvailable: true,
        isLoading: false
      };
    },
    computed: {
      isComingSoonProduct() {
        if (!this.selectedProduct || !this.comingsoon_tag) {
          return false;
        }
        return this.selectedProduct.tags.includes(this.comingsoon_tag);
      },
      checkSoldOutMessage() {
        if (!this.activeVariant && !this.isComingSoonProduct) {
          return this.unavailableText;
        }
        return this.SoldOutText;
      },
      isCurrentVariantAvailable() {
        if (!this.activeVariant) return false;

        for (const product of this.products) {
          for (const variant of product.variants.edges) {
            if (variant.node.id === this.activeVariant) {
              return variant.node.availableForSale;
            }
          }
        }
        return false;
      },
      ctlAddAriaLabel() {
        if (this.bagMessage == null || this.bagMessage === '') return '';
        const tmp = document.createElement('span');
        tmp.innerHTML = this.bagMessage;
        return (tmp.textContent || '').replace(/\s+/g, ' ').trim();
      }
    },
    methods: {
      hasColorOption(product) {
        return product.variants.edges.some(vart => vart.node.selectedOptions.some(option => option.name.toLowerCase() === 'color'));
      },
      hasSizeOption(product) {
        return product.variants.edges.some(vart => vart.node.selectedOptions.some(option => option.name.toLowerCase() === 'size'));
      },
      setOptionTwoWidth() {
        var biggestWidth = 0;
        [...document.querySelectorAll('#CompleteTheLook .option2')].forEach(item => {
          item.style.width = 'auto';
          var width = item.offsetWidth;
          if (width > biggestWidth) {
            biggestWidth = width;
          }
        });
        [...document.querySelectorAll('#CompleteTheLook .option2')].forEach(item => {
          item.style.width = biggestWidth + 'px';
        });
      },
      setOptionThreeWidth() {
        var biggestWidth = 0;
        [...document.querySelectorAll('#CompleteTheLook .option2')].forEach(item => {
          item.style.width = 'auto';
          var width = item.offsetWidth;
          if (width > biggestWidth) {
            biggestWidth = width;
          }
        });
        [...document.querySelectorAll('#CompleteTheLook .option2')].forEach(item => {
          item.style.width = biggestWidth + 'px';
        });
      },
      productUrl(handle) {
        return `${window.theme?.routes?.root_url || '/'}products/${handle}`;
      },
      clickDetails() {
        window.setFindingMethod('Complete The Look');
      },
      setImageSize(imgUrl) {
        if (imgUrl) {
          if (imgUrl.includes('?') && typeof imgUrl != 'undefined') {
            return imgUrl + '&width=200';
          } else {
            return imgUrl + '?width=200';
          }
        } else {
          return '';
        }
      },
      configImageUrl(name) {
        return (
          window.cdn +
          name
            .toLowerCase()
            .replace(/\./gim, '')
            .replace(/[/|\s|&|\\]/gim, '-') +
          '.png'
        );
      },
      setTag() {
        if (!this.ctlIds) {
          this.CTLPids = [];
          this.requestProductsData();
          return;
        }

        let pids = [];
        if (Array.isArray(this.ctlIds)) {
          pids = this.ctlIds;
        } else if (typeof this.ctlIds === 'string') {
          try {
            const parsed = JSON.parse(this.ctlIds);
            if (Array.isArray(parsed)) {
              pids = parsed;
            }
          } catch (e) {
            console.error('CompleteTheLookDisplay: Invalid ctlIds JSON', {
              ctlIds: this.ctlIds,
              error: e?.message || e
            });
          }
        }

        this.CTLPids = pids;
        this.requestProductsData();
      },
      requestProductsData() {
        if (this.CTLPids.length > 0) {
          storefront
            .request(queries.completeTheRoom, {
              variables: {
                ids: this.CTLPids.map(id => id)
              }
            })
            .then(response => {
              this.products = response.data.nodes;
              const cleanProducts = [];
              for (let i = 0; i < this.products.length; i++) {
                if (this.products[i]?.handle.length > 0 && this.products[i]?.availableForSale === true && this.products[i]?.title?.replace(/\s+/g, ' ').trim()) {
                  this.products[i] && cleanProducts.push(this.setOptionsDisplays(this.products[i]));
                }
              }
              this.products = cleanProducts;

              emitter.emit('ctl-products-updated', {
                hasProducts: cleanProducts.length > 0
              });

              if (cleanProducts.length > 0) {
                this.$nextTick(() => {
                  this.showDetails(this.products[0]?.handle);
                });

                if (this.reactiveCtlTags) {
                  const reactiveTags = (this.reactiveCtlTags || '')
                    .split(',')
                    .map(t => t.trim())
                    .filter(Boolean);
                  this.products.forEach(product => {
                    if (reactiveTags.some(tag => product.tags?.includes(tag))) {
                      emitter.on('reactive-ctl-image-updated', e => {
                        if (e.handle === product.handle && e.sku) {
                          product.variants.edges.forEach(variant => {
                            if (variant.node.sku === e.sku) {
                              const variantImageUrl = variant.node.image?.url;
                              if (variantImageUrl) {
                                product.displayImageUrl = variantImageUrl;
                              }
                            }
                          });
                        }
                      });
                    }
                  });
                }
              }
            })
            .catch(e => {
              console.error('CompleteTheLookDisplay: failed to load CTL products', {
                error: e?.message || e
              });
              emitter.emit('ctl-products-updated', {
                hasProducts: false
              });
            });
        } else {
          emitter.emit('ctl-products-updated', {
            hasProducts: false
          });
        }
      },
      setOptionsDisplays(prods) {
        prods.variants.edges.forEach(nod => {
          if (nod.node.selectedOptions[1]) {
            this.optOneName = nod.node.selectedOptions[1].name;
            this.handleSize(nod.node.selectedOptions[1].value);
          }
          if (nod.node.selectedOptions[2]) {
            this.optTwoName = nod.node.selectedOptions[2].name;
            this.handleRhinestone(nod.node.selectedOptions[2].value);
          }
        });

        prods.sizes = this.sortOptionTwoData(toRaw(this.sizes), prods.tags);
        prods.stones = this.sortOptionThreeData(toRaw(this.stones));
        prods.optOneName = this.optOneName;
        prods.optTwoName = this.optTwoName;
        prods.displayImageUrl = prods?.images?.edges?.[0]?.node?.url;
        this.sizes = [];
        this.stones = [];
        return prods;
      },
      handleSize(size) {
        if (this.sizes.includes(size)) {
          // nothing
        } else {
          this.sizes.push(size);
        }
      },
      handleRhinestone(stone) {
        if (this.stones.includes(stone)) {
          // nothing
        } else {
          this.stones.push(stone);
        }
      },
      cleanPassCSVData(string) {
        if (!string) return [];
        var arr = string.split(',').map(function (item) {
          return item.trim();
        });
        return arr;
      },
      sortOptionTwoData(passed, tags) {
        let sortingArr = this.cleanPassCSVData(this.optiontwoorder);
        if (tags && this.optiontwoorderoverridetag) {
          if (tags.includes(this.optiontwoorderoverridetag)) {
            sortingArr = this.cleanPassCSVData(this.optiontwoorderoverride);
          }
        }
        return passed.sort((a, b) => sortingArr.indexOf(a) - sortingArr.indexOf(b));
      },
      sortOptionThreeData(passed) {
        const sortingArr = this.cleanPassCSVData(this.optionthreeorder);
        return passed.sort((a, b) => sortingArr.indexOf(a) - sortingArr.indexOf(b));
      },
      selectDefaultsByHandle(handle) {
        this.products.forEach(product => {
          if (product.handle === handle) {
            product.variants.edges.forEach(nod => {
              if (nod.node.selectedOptions.some(option => option.value.toLowerCase() === 'default title')) {
                this.currentSize = null;
              }
              if (this.currentSize === '' && nod.node.selectedOptions[0] && nod.node.selectedOptions[0].name.toLowerCase().includes('size')) {
                this.currentSize = nod.node.selectedOptions[0].value;
              }
              if (this.currentSize === '' && nod.node.selectedOptions[1]) {
                this.currentSize = nod.node.selectedOptions[1].value;
              }
              if (this.currentStone === '' && nod.node.selectedOptions[2]) {
                this.currentStone = nod.node.selectedOptions[2].value;
              }
            });
          }
        });
        this.resetStones(handle);
        this.resetSizes(handle);
        this.$nextTick(() => {
          this.selectFirstOptions(handle);
        });
        this.setOptionTwoWidth();
        this.setOptionThreeWidth();
      },
      selectFirstOptions(handle) {
        const detailsActiveVariantsStone = document.getElementById(handle + '_stones');
        if (detailsActiveVariantsStone) {
          const selectedStone = detailsActiveVariantsStone.querySelectorAll('[data-stone-id]')[0];
          if (selectedStone) {
            selectedStone.click();
          }
        }
        const detailsActiveVariantsSize = document.getElementById(handle + '_sizes');
        if (detailsActiveVariantsSize) {
          const selectedSize = detailsActiveVariantsSize.querySelectorAll('[data-size-id]')[0];
          if (selectedSize) {
            selectedSize.click();
          }
        }
      },
      showDetails(did) {
        this.currentSize = '';
        this.currentStone = '';
        const CTLParents = document.querySelectorAll('.ctl-parent');
        [...CTLParents].forEach(parents => {
          parents.classList.remove('selected');
        });

        const newActive = document.getElementById(did + '_parent');
        if (newActive) {
          newActive.classList.add('selected');
        }
        const CTLDetails = document.querySelectorAll('.ctl-details');
        [...CTLDetails].forEach(details => {
          details.classList.remove('selected');
        });
        const detailsActive = document.getElementById(did + '_details');
        if (detailsActive) {
          detailsActive.classList.add('selected');
        }
        this.selectedProduct = this.products.find(product => product.handle === did);
        if (this.selectedProduct) {
          this.optOneName = this.selectedProduct.optOneName || '';
          this.optTwoName = this.selectedProduct.optTwoName || '';
          const colorOpt = this.selectedProduct.variants?.edges?.[0]?.node?.selectedOptions?.find(o => o.name.toLowerCase() === 'color');
          this.currentColor = colorOpt?.value || '';
        }
        this.selectDefaultsByHandle(did);
        this.setBagButtons(did);
      },
      isOnSalePrice() {
        if (this.activeComparePrice === '') {
          return 'price';
        } else {
          return 'compare on-sale';
        }
      },
      getPriceClass() {
        if (this.percentage === '') {
          return 'price';
        } else {
          return 'price strike';
        }
      },

      isExcludedDefaultOption(name) {
        var excluded = window.pdpIncludedProductType.split(',') || [];
        if (excluded.includes(name)) {
          if (this.hideOption3TitleTags && this.selectedProduct?.tags?.includes(this.hideOption3TitleTags)) {
            return 'option p-options option3 hide-title';
          } else {
            return 'option p-options option3';
          }
        }
        return 'option p-options option2';
      },
      getAddBagClass() {
        if (this.bagMessage === this.addToCartText) {
          this.checkSelected();
          return 'ctl-add-bag gt-p';
        } else {
          return 'ctl-add-bag gt-p oos';
        }
      },
      getProductMasterIDfromBase(str) {
        const decodedStr = str;
        const vid = decodedStr.replace('gid://shopify/Product/', '');
        return vid;
      },
      addToBag() {
        if (this.isLoading) {
          return;
        }
        window.setFindingMethod('Complete The Look:PDP');
        var self = this;
        if (this.activeVariant) {
          const varId = this.activeVariant.replace('gid://shopify/ProductVariant/', '');
          if (this.bagMessage === this.addToCartText) {
            this.isLoading = true;
            const item = {
              id: varId,
              quantity: 1
            };
            const finalSaleProperties = getFinalSaleLineItemProperties(this.selectedProduct?.tags, this.selectedProduct?.title);
            if (finalSaleProperties) {
              item.properties = finalSaleProperties;
            }
            const formData = {
              items: [item]
            };
            (window.theme && window.theme.fetchWithRetry ? window.theme.fetchWithRetry : window.fetch)
              .call(window, window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              })
              .then(response => response.json())
              .then(function (data) {
                if (data.status === 422) {
                  this.error(data);
                } else {
                  self.reloadCart();
                }
              })
              .finally(() => {
                self.isLoading = false;
              });
          }
        }
      },
      setBagButtons(handle) {
        let available = false;
        let foundVariant;
        this.activeVariant = '';
        this.products.forEach(product => {
          if (product.handle === handle) {
            let foundSize = false;
            let foundStone = false;
            product.variants.edges.forEach(nod => {
              const optionZeroIsSize = nod.node.selectedOptions[0].name.toLowerCase().includes('size');
              if (optionZeroIsSize) {
                if (this.currentSize === nod.node.selectedOptions[0].value) {
                  foundSize = true;
                } else {
                  foundSize = false;
                }
              } else if (nod.node.selectedOptions[1]) {
                if (this.currentSize === nod.node.selectedOptions[1].value) {
                  foundSize = true;
                } else {
                  foundSize = false;
                }
              } else {
                foundSize = true;
              }

              if (nod.node.selectedOptions[2]) {
                if (this.currentStone === nod.node.selectedOptions[2].value) {
                  foundStone = true;
                } else {
                  foundStone = false;
                }
              } else {
                foundStone = true;
              }

              if (foundSize && foundStone) {
                foundVariant = nod.node.id;
                available = nod.node.availableForSale;
              }
            });
          }
        });
        this.activeVariant = foundVariant;
        this.currentVariantAvailable = available;
        if (available) {
          this.bagMessage = this.addToCartText;
        } else {
          this.bagMessage = this.SoldOutText;
          this.setSizeAvail(handle, this.currentSize, false);
          this.setStoneAvail(handle, this.currentStone, false);
        }
        this.checkInventoryAndPrice(handle);
      },

      checkInventoryAndPrice(handle) {
        this.resetStones(handle);
        this.resetSizes(handle);
        this.percentage = '';
        this.activeComparePrice = '';
        this.activePrice = '';
        let price, compare;
        var formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        });

        this.products.forEach(product => {
          if (product.handle === handle) {
            product.variants.edges.forEach(vard => {
              if (vard.node.id === this.activeVariant) {
                price = vard.node.price.amount;
                compare = vard.node?.compareAtPrice?.amount || '';
              }
              const optionZeroIsSize = vard.node.selectedOptions[0].name.toLowerCase().includes('size');
              if ((optionZeroIsSize || vard.node.selectedOptions[1]) && !vard.node.selectedOptions[2]) {
                // handle no 3rd option
                const avail = vard.node.availableForSale;
                if (optionZeroIsSize) {
                  this.setSizeAvail(handle, vard.node.selectedOptions[0].value, avail);
                } else {
                  this.setSizeAvail(handle, vard.node.selectedOptions[1].value, avail);
                }
              }

              if (((optionZeroIsSize && vard.node.selectedOptions[0].value === this.currentSize) || (vard.node.selectedOptions[1] && vard.node.selectedOptions[1].value === this.currentSize)) && vard.node.selectedOptions[2]) {
                // handle 3rd option
                const avail = vard.node.availableForSale;
                this.setStoneAvail(handle, vard.node.selectedOptions[2].value, avail);
              }
              if (vard.node.selectedOptions[2] && vard.node.selectedOptions[2].value === this.currentStone) {
                // handle 2rd option when 3rd is available
                const avail = vard.node.availableForSale;
                if (optionZeroIsSize) {
                  this.setSizeAvail(handle, vard.node.selectedOptions[0].value, avail);
                } else {
                  this.setSizeAvail(handle, vard.node.selectedOptions[1].value, avail);
                }
              }
            });
          }
        });

        const comparePrice = parseFloat(compare) || 0;
        const currentPrice = parseFloat(price) || 0;

        if (currentPrice > 0) {
          this.activePrice = formatter.format(currentPrice);
        }
        if (comparePrice > 0 && comparePrice > currentPrice) {
          this.activeComparePrice = formatter.format(comparePrice);
          const percentage = Math.round((100 * (comparePrice - currentPrice)) / comparePrice);
          this.percentage = '(' + percentage + '% off)';
        }
      },

      setStone(stones, handle) {
        const detailsActiveVariants = document.getElementById(handle + '_stones');
        const variants = detailsActiveVariants.querySelectorAll('.stone');
        [...variants].forEach(stone => {
          stone.classList.remove('selected');
        });
        const selected = detailsActiveVariants.querySelectorAll(`[data-stone-id='${CSS.escape(stones)}']`)[0];
        selected.classList.add('selected');
        this.currentStone = stones;
        this.setBagButtons(handle);
        const prod = this.products.find(p => p.handle === handle);
        let sku = null;
        if (prod) {
          prod.variants.edges.forEach(v => {
            if (v.node.id === this.activeVariant) {
              sku = v.node.sku;
            }
          });
        }
        const reactiveTagsStone = (this.reactiveCtlTags || '')
          .split(',')
          .map(t => t.trim())
          .filter(Boolean);
        if (reactiveTagsStone.length && reactiveTagsStone.some(tag => prod?.tags?.includes(tag))) {
          emitter.emit('reactive-ctl-image-updated', {
            handle: handle,
            sku: sku
          });
        }
      },
      setSize(sizes, handle) {
        const detailsActiveVariants = document.getElementById(handle + '_sizes');
        const variants = detailsActiveVariants.querySelectorAll('.option.p-options.option2');
        [...variants].forEach(size => {
          size.classList.remove('selected');
        });
        const selected = detailsActiveVariants.querySelectorAll(`[data-size-id='${CSS.escape(sizes)}']`)[0];
        selected.classList.add('selected');
        this.currentSize = sizes;
        this.setBagButtons(handle);
        const prod = this.products.find(p => p.handle === handle);
        let sku = null;
        if (prod) {
          prod.variants.edges.forEach(v => {
            if (v.node.id === this.activeVariant) {
              sku = v.node.sku;
            }
          });
        }
        const reactiveTagsSize = (this.reactiveCtlTags || '')
          .split(',')
          .map(t => t.trim())
          .filter(Boolean);
        if (reactiveTagsSize.length && reactiveTagsSize.some(tag => prod?.tags?.includes(tag))) {
          emitter.emit('reactive-ctl-image-updated', {
            handle: handle,
            sku: sku
          });
        }
      },
      ctlOptionAriaLabel(title, optionKind, optionValue, available, includeSizeContext) {
        const parts = [];
        if (this.currentColor) parts.push(`color ${this.currentColor}`);
        if (includeSizeContext && this.currentSize) parts.push(`size ${this.currentSize}`);
        const context = parts.length ? ` in ${parts.join(' ')}` : '';
        const status = available ? 'available' : 'currently unavailable';
        return `${title}${context} ${optionKind} option: ${optionValue} is ${status}`;
      },
      setSizeAvail(handle, size, avail) {
        const detailsActiveVariants = document.getElementById(handle + '_sizes');
        if (detailsActiveVariants) {
          const selected = detailsActiveVariants.querySelectorAll(`[data-size-id='${CSS.escape(size)}']`)[0];
          if (selected) {
            if (avail) {
              selected.classList.remove('disabled', 'unavailable');
            } else {
              selected.classList.add('disabled', 'unavailable');
            }
            const title = (this.products.find(p => p.handle === handle) || this.selectedProduct)?.title || '';
            selected.setAttribute('aria-label', this.ctlOptionAriaLabel(title, 'size', size, avail, false));
          }
        }
      },
      resetStones(handle) {
        const detailsActiveVariants = document.getElementById(handle + '_stones');
        if (detailsActiveVariants) {
          const title = (this.products.find(p => p.handle === handle) || this.selectedProduct)?.title || '';
          const optionKind = (this.optTwoName || 'width').toLowerCase();
          [...detailsActiveVariants.querySelectorAll('a')].forEach(select => {
            select.classList.add('disabled', 'unavailable');
            select.setAttribute('aria-label', this.ctlOptionAriaLabel(title, optionKind, select.getAttribute('data-stone-id'), false, true));
          });
        }
      },
      resetSizes(handle) {
        const detailsActiveVariants = document.getElementById(handle + '_sizes');
        if (detailsActiveVariants) {
          const title = (this.products.find(p => p.handle === handle) || this.selectedProduct)?.title || '';
          [...detailsActiveVariants.querySelectorAll('a')].forEach(select => {
            select.classList.add('disabled', 'unavailable');
            select.setAttribute('aria-label', this.ctlOptionAriaLabel(title, 'size', select.getAttribute('data-size-id'), false, false));
          });
        }
      },
      setStoneAvail(handle, stone, avail) {
        const detailsActiveVariants = document.getElementById(handle + '_stones');
        const selected = detailsActiveVariants?.querySelectorAll(`[data-stone-id='${CSS.escape(stone)}']`)[0];
        if (avail) {
          selected?.classList.remove('disabled', 'unavailable');
        } else {
          selected?.classList.add('disabled', 'unavailable');
        }
        if (selected) {
          const title = (this.products.find(p => p.handle === handle) || this.selectedProduct)?.title || '';
          const optionKind = (this.optTwoName || 'width').toLowerCase();
          selected.setAttribute('aria-label', this.ctlOptionAriaLabel(title, optionKind, stone, avail, true));
        }
      },
      checkSelected() {
        const widget = document.getElementById('extended-ctl');
        const title = this.selectedProduct?.title || '';
        const optionKind = (this.optTwoName || 'width').toLowerCase();
        if (this.currentStone != '') {
          const selectedStone = widget.querySelectorAll(`[data-stone-id='${CSS.escape(this.currentStone)}']`)[0];
          if (selectedStone) {
            selectedStone.classList.remove('disabled', 'unavailable');
            selectedStone.setAttribute('aria-label', this.ctlOptionAriaLabel(title, optionKind, this.currentStone, true, true));
          }
        }
        if (this.currentSize != '') {
          const selectedSize = widget.querySelectorAll(`[data-size-id='${CSS.escape(this.currentSize)}']`)[0];
          if (selectedSize) {
            selectedSize.classList.remove('disabled', 'unavailable');
            selectedSize.setAttribute('aria-label', this.ctlOptionAriaLabel(title, 'size', this.currentSize, true, false));
          }
        }
      },
      reloadCart() {
        var self = this;
        const cartRequest = window.theme && window.theme.getCart ? window.theme.getCart(true) : fetchWrapper.get(`${window.theme.routes.cart}.js`).then(response => response.json());
        cartRequest
          .then(cart => {
            document.dispatchEvent(
              new CustomEvent('theme:cart:change', {
                detail: {
                  cart
                },
                bubbles: true
              })
            );
            document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
            setTimeout(() => {
              [...document.querySelectorAll("[ data-drawer-toggle='drawer-cart']")].forEach(function (el) {
                el.click();
              });
              self.loading = false;
            }, 300);
          })
          .catch(e => {
            console.error('CompleteTheLookDisplay: Error loading widget:', {
              error: e?.message || e,
              stack: e?.stack,
              response: e?.response,
              fullError: e
            });
            self.showWidget = false;
            self.error = true;
          });
      }
    }
  };
</script>

<template>
  <div id="extended-ctl">
    <div v-if="hasProducts">
      <div class="f fw flex-row">
        <div v-for="(product, index) in products" class="product__complete-look" :key="product.handle + '_' + index">
          <a @click="showDetails(product.handle)" :class="index == 0 ? 'selected ctl-parent' : 'ctl-parent'" :id="product.handle + '_parent'" tabindex="0">
            <span class="helper"></span>
            <img :src="setImageSize(product.displayImageUrl)" :alt="product.title" />
            <span class="helper hider"></span>
          </a>
        </div>
      </div>
      <div v-if="products.length > 0">
        <div v-for="(product, index) in products" :class="index == 0 ? 'selected ctl-details' : 'ctl-details'" :id="product.handle + '_details'" :key="product.handle + '__' + index">
          <div class="topInfo">
            <p class="black-title details-topper gt-p__small" v-html="product.title"></p>
            <p class="price-details gt-p__small">
              <span :class="isOnSalePrice()" v-html="activePrice"></span>
              <span :class="getPriceClass()" v-html="activeComparePrice"></span>
              <span class="percentage on-sale gt-p__small" v-html="percentage"></span>
            </p>
          </div>
          <div class="topInfo">
            <template v-for="(vart, varIndex) in product.variants.edges">
              <template v-for="(color, colorIndex) in vart.node.selectedOptions">
                <p v-html="'Color: ' + color.value" v-if="color.name == 'Color'" :class="varIndex == 0 ? 'selected ctl-color gt-p__small' : 'ctl-color gt-p__small'" :key="color.name + '_' + colorIndex"></p>
              </template>
            </template>
            <a v-if="hasColorOption(product)" :href="productUrl(product.handle)" @click="clickDetails" class="full-details gt-p__small">Full Details</a>
          </div>

          <div v-if="!isComingSoonProduct" class="topInfo">
            <template v-if="currentSize">
              <p v-html="optOneName + ': ' + currentSize" class="selected ctl-color gt-p__small"></p>
            </template>
            <a v-if="!hasColorOption(product)" :href="productUrl(product.handle)" @click="clickDetails" class="full-details gt-p__small">Full Details</a>
          </div>
          <div v-if="!isComingSoonProduct" class="f fw flex-row flex-wrap flex-wrap-size" :id="product.handle + '_sizes'">
            <template v-for="(size, sizeIndex) in product.sizes" :key="sizeIndex + '_' + product.handle">
              <a v-html="size" :class="isExcludedDefaultOption(optOneName)" :data-size-id="size" @click="setSize(size, product.handle)" :style="showImage2 ? 'background-image:url(' + configImageUrl(size) + ')' : ''" tabindex="0"></a>
            </template>
          </div>

          <div class="topInfo" v-if="currentStone && !isComingSoonProduct" style="margin-top: 0px">
            <p v-html="optTwoName + ': ' + currentStone" class="selected ctl-color gt-p__small"></p>
          </div>
          <div class="f fw flex-row flex-wrap flex-wrap-stone" :id="product.handle + '_stones'" v-if="!isComingSoonProduct">
            <template v-for="(stone, stoneIndex) in product.stones" :key="stoneIndex + '_' + product.handle">
              <a :class="isExcludedDefaultOption(optTwoName)" class="stone" :data-stone-id="stone" v-html="stone" :style="showImage3 ? 'background-image:url(' + configImageUrl(stone) + ')' : ''" @click="setStone(stone, product.handle)" tabindex="0"></a>
            </template>
          </div>
        </div>

        <div id="add-to-bag-buttons">
          <div v-if="isComingSoonProduct" class="ctl-add-bag gt-p coming-soon-true" data-add-to-cart-text="" v-html="comingsoonText"></div>

          <button type="button" v-else-if="currentVariantAvailable && !isComingSoonProduct" data-add-to-cart="" :class="[getAddBagClass(), { loading: isLoading }]" :aria-busy="isLoading ? true : undefined" :aria-label="ctlAddAriaLabel" @click="addToBag()" :disabled="isLoading">
            <span v-html="bagMessage" data-add-to-cart-text="" class="btn-state-ready"></span>
            <span class="btn-state-loading" aria-hidden="true">
              <svg height="18" width="18" class="svg-loader">
                <circle r="7" cx="9" cy="9"></circle>
                <circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9"></circle>
              </svg>
            </span>

            <span class="btn-state-complete" aria-hidden="true">&nbsp;</span>
          </button>

          <div v-else-if="!currentVariantAvailable && !isComingSoonProduct" class="ctl-add-bag gt-p oos" data-add-to-cart-text="" v-html="checkSoldOutMessage"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  #CompleteTheLook {
    .flex-wrap {
      display: flex;
      flex-wrap: wrap;
      padding-left: 1px;
      margin-bottom: 15px;
    }

    ul:not(.draw) {
      li {
        list-style: outside;
        margin-left: 20px;
      }
    }
  }

  .product__complete-look {
    display: inline-flex;
    position: relative;
    max-width: 86px;
    width: 100%;
    margin-bottom: 16px;

    .is-mobile & {
      max-width: 82px;
    }

    &:not(:last-child) {
      margin-right: 16px;

      .is-mobile & {
        margin-right: 8px;
      }
    }

    a {
      width: 100%;
      cursor: pointer;
      position: relative;
      z-index: 1;
      height: 100%;
      vertical-align: top;
    }

    img {
      vertical-align: middle;
    }

    a {
      &.ctl-parent {
        border: 1px solid transparent;
      }

      &.selected {
        .helper.hider {
          display: block;
          pointer-events: none;
        }

        img {
          border: 1px solid #000;
        }
      }
    }

    .helper {
      display: inline-block;
      height: 100%;
      vertical-align: middle;
      z-index: 1;
      pointer-events: none;

      &.hider {
        display: none;
      }
    }
  }

  .ctl-details {
    display: none;

    &.selected {
      display: block;
    }
  }

  .variant__label-circle-variant__size {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 0;
    padding-top: 2px;
    padding-left: 9px;
    padding-right: 9px;
    border-radius: 4px;
    height: 34px;
    box-sizing: border-box;
    border: 1px solid #d1d1d6;
    margin-right: 9px;
    margin-bottom: 6px;
    min-width: 43px;
    cursor: pointer;
    font-size: 14px;

    .is-mobile & {
      font-size: 16px;
    }

    &.disabled {
      text-decoration: line-through;
      color: grey;
    }

    &.selected {
      border-color: #000;
    }
  }

  .product-swatch__button.product-swatch__button--circle {
    img {
      border: 1px solid #fff;
    }

    &.selected {
      img {
        border-color: #000;
      }
    }
  }

  .full-details {
    text-decoration: underline;
    margin-left: auto;
    margin-top: 1px;
    cursor: pointer;
  }

  .price-details {
    text-align: right;
    margin-bottom: 0;
    flex: 0 0 auto;
  }

  .ctl-add-bag {
    padding: 8px;
    text-align: center;
    border: 1px solid #000;
    border-radius: var(--BUTTON-RADIUS);
    cursor: pointer;
    text-transform: uppercase;
    margin-top: 6px;
    letter-spacing: 0.3em;
    min-height: 37.5px;

    &[type='button'] {
      width: 100%;
      font: inherit;
      color: inherit;
      background: transparent;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
    }

    &.oos {
      background-color: #d9d9d9;
      border: 1px solid #d9d9d9;
    }

    &:empty {
      display: none;
    }

    &.loading {
      position: relative;
    }
  }

  .ctl-color {
    display: none;

    &.selected {
      display: block;
      margin-bottom: 9px;
    }
  }

  [v-cloak] > * {
    display: none;
  }

  .topInfo {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: -5px;
  }

  .details-topper {
    flex: 1 1 auto;
    padding-right: 10px;
  }

  .flex-wrap {
    flex-wrap: wrap;
  }

  .product__complete-look__tooltip {
    position: fixed;
    padding: 5px;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.6);
    border: 1px solid #c3c3c3;
    overflow: hidden;
    z-index: 5;
  }

  .price.strike {
    text-decoration: line-through;
    margin-left: 5px;
    margin-right: 5px;
  }

  .product__complete-look img {
    height: auto;
    max-height: 128px;

    .is-mobile & {
      max-height: 120px;
    }
  }

  .no-show {
    display: none !important;
  }
</style>
